/**
 * User: nir
 * Date: 22/09/2016
 * Time: 17:38
 */

window.TCT = window.TCT || {};
window.TCT.JWPlayer = window.TCT.JWPlayer || {
        setTargetingParams: function (playlistItem) {
            // get the player
            var player = this;
            if (player && playlistItem && window['TCTTargeting']) {
                // copy all targeting parameters to the playlist item
                for (var key in TCTTargeting) {
                    if (TCTTargeting.hasOwnProperty(key)) {
                        var value = TCTTargeting[key];
                        playlistItem[key] = value instanceof Array ? value.join(',') : value;
                    }
                }
            }

            if (TCT && TCT.debug) TCT.debug('JWPlayer Ad Targeting:', playlistItem);
        }
    };